import React, { useState } from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { signInWithEmail } from "../../../apis/firebase";

export const EmailPasswordForm = ({ registrationEnabled }) => {
  const [loginError, setLoginError] = useState("");
  const [hidePassword, setHidePassword] = useState(true);

  const initialValues = {
    email: "",
    password: "",
    name: "",
  };

  const { t } = useTranslation();

  const FormSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("FORM_EMAIL_VALIDATION_FORMAT"))
      .min(3, t("FORM_EMAIL_VALIDATION_MIN_LENGTH"))
      .max(50, t("FORM_EMAIL_VALIDATION_MAX_LENGTH"))
      .required(t("FORM_REQUIRED_FIELD")),

    password: Yup.string().required(t("FORM_REQUIRED_FIELD")),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: FormSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        await signInWithEmail(values.email, values.password);
      } catch (e) {
        if (e === "auth/user-not-found" || e === "auth/wrong-password") {
          setLoginError(t("ERROR_LOGIN_WRONG_CREDENTIAL"));
        } else {
          setLoginError(t("ERROR_LOGIN_SOMETHING_WRONG"));
        }
        console.log(e);
      }
    },
  });
  return (
    <form onSubmit={formik.handleSubmit}>
      {loginError && (
        <div className="alert alert-danger py-1 px-2 fs-7" role="alert">
          <i className="bi bi-exclamation-circle-fill me-1"></i>
          {loginError}
        </div>
      )}

      <div className="mb-3">
        <input
          type="email"
          name="email"
          className={`form-control ${formik.errors.email ? "is-invalid" : ""}`}
          placeholder={t("FORM_EMAIL_PLACEHOLDER")}
          {...formik.getFieldProps("email")}
        />
        {formik.touched.email && formik.errors.email ? (
          <div className="invalid-feedback error-block">
            {formik.errors.email}
          </div>
        ) : null}
      </div>

      <div className="mb-3">
        <div className="input-group ">
          <input
            type={hidePassword ? "password" : "text"}
            placeholder={t("FORM_PASSWORD_PLACEHOLDER")}
            className={`form-control ${
              formik.errors.password ? "is-invalid" : ""
            }`}
            name="password"
            {...formik.getFieldProps("password")}
          />
          <div className="input-group-text">
            <button
              type="button"
              className="bi bi-eye-fill"
              onClick={() => {
                setHidePassword(!hidePassword);
              }}
            />
          </div>
          {formik.touched.password && formik.errors.password ? (
            <div className="invalid-feedback error-block">
              {formik.errors.password}
            </div>
          ) : null}
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between mb-4">
        <Link to="/forgot-password" className="text-primary fw-bold fs-7">
          {t("FORGOT_PASSWORD_TITLE")}
        </Link>
      </div>

      <div className="mt-2">
        <button type="submit" className="btn btn-primary fw-bold w-100">
          {t("FORM_BUTTON_LOGIN_LABEL")}
        </button>
      </div>

      {registrationEnabled && (
        <div className="mt-4">
          <Link to="/register" className="btn btn-secondary fw-bold w-100">
            {t("FORM_BUTTON_REGISTER_LABEL")}
          </Link>
        </div>
      )}
    </form>
  );
};

export default EmailPasswordForm;
